import 'css-chunksrc/client/common/selectList/styles.scss';export default {
  "selectList": "_selectList_16q8l_1",
  "input": "_input_16q8l_5",
  "list": "_list_16q8l_10",
  "displayBehavior": "_displayBehavior_16q8l_16",
  "opened": "_opened_16q8l_20"
};